import { FC } from 'react';

export const NotFound: FC = () => <div className="flex justify-center items-center h-full font-light">Page Not Found</div>;
